export default __webpack_public_path__ + "static/media/professioni_neg.b27e0187.svg";